// sharedData/Observable.js
import { sharedData } from "../sharedData/sharedData";

class EnhancedObservable {

  static instance;

  constructor(key) {
    this.key = key;
    this.value = sharedData.get("riskAssesContStatus") || null;
    this.currentList = sharedData.get("riskAssesContObservable") || [];
    this.subscribers = [];
  }

  get value() {
    return sharedData.get("riskAssesContStatus") || null;
  }

  set value(val) {
    sharedData.set("riskAssesContStatus", val);
  }

  get currentList() {
    return sharedData.get("riskAssesContObservable") || [];
  }

  set currentList(list) {
    sharedData.set("riskAssesContObservable", list);
  }

  subscribe(callback) {
    this.subscribers.push(callback);
    return {
      unsubscribe: () => {
        this.subscribers = this.subscribers.filter(cb => cb !== callback);
      }
    };
  }

  notifySubscribers() {
    this.subscribers.forEach(cb => cb());
  }

  saveList() {
    sharedData.set("riskAssesContObservable", this.currentList);
  }

  saveValue() {
    sharedData.set("riskAssesContStatus", this.value)
  }

  createValue(value, ownerId) {
    return {
        value: value,
        by: ownerId
    }
  }

  isContinue() {
    if (this.currentList === null || this.currentList === undefined || this.currentList.length === 0) {
      return false;
    }
    return this.currentList.some(obj => obj.value === true);
  }

  isContinueButNotBy(ownerId) {
    return this.currentList.some(obj => obj.value === true && obj.by !== ownerId);
  }

  isContinueBy() {
    const obj = this.currentList.find(obj => obj.value === true);
    return obj ? obj.by : null;
  }

  checkFinal() {
    return this.isContinue();
  }

  setForce(value) {
    this.value = value;
  }

  setContinue(ownerId) {
    const existingIndex = this.currentList.findIndex(obj => obj.by === ownerId);
    let updatedList;
  
    if (existingIndex !== -1) {
      // Update existing entry
      updatedList = [...this.currentList];
      updatedList[existingIndex].value = true;
    } else {
      // Add new entry
      updatedList = [...this.currentList, this.createValue(true, ownerId)];
    }
  
    this.currentList = updatedList;
     // ✅ Save the list so it's persisted
  this.saveList();

  // ✅ Optional: also set general status flag
  this.value = true;
  this.saveValue();
    this.notifySubscribers();
  }

  getValue(ownerId) {
    return this.currentList.find(obj => obj.by === ownerId);
  }

  remove(ownerId) {
    this.currentList = this.currentList.filter(obj => obj.by !== ownerId);
    this.notifySubscribers();
  }

  removeByPrefix(prefix) {
    this.currentList = this.currentList.filter(obj => !obj.by.startsWith(prefix));
    this.notifySubscribers();
  }

  static getInstance(key) {
    if (!this.instance) {
      this.instance = new EnhancedObservable(key);
    }
    return this.instance;
  }
  getContinueKeys() {
    return this.currentList
      .filter(item => item.value === true)
      .map(item => item.by);
  }
}

export const riskAssesContObservable = EnhancedObservable.getInstance("riskAssesContStatus");